import { render } from "./StudentsComponent.vue?vue&type=template&id=6951c947"
import script from "./StudentsComponent.vue?vue&type=script&lang=js"
export * from "./StudentsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__